import { useUnifiedProfilesActions } from '@/features/unifiedProfiles/context';
import { Input } from '@/lib';
import { FC, KeyboardEventHandler, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ClearButton } from './ClearButton';

type UnifiedProfileSearchInputProps = {
  value: string;
  className?: string;
  onChange: (value: string) => void;
  executeSearch: VoidFunction;
  setOptionsVisibility: (value: boolean) => void;
};

export const UnifiedProfileSearchInput: FC<UnifiedProfileSearchInputProps> = ({ value, className, onChange, executeSearch, setOptionsVisibility }) => {
  const { t } = useTranslation('unifiedProfile');
  const { setSearchText } = useUnifiedProfilesActions();

  const handleInputKeyDown = useCallback<KeyboardEventHandler<HTMLInputElement>>(
    (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        executeSearch();
      }
    },
    [executeSearch]
  );

  const handleWrapperKeyDown = useCallback<KeyboardEventHandler<HTMLInputElement>>(
    (e) => {
      if (e.key === 'ArrowDown') {
        setOptionsVisibility(true);
      }
      if (e.key === 'ArrowUp') {
        setOptionsVisibility(false);
      }
    },
    [setOptionsVisibility]
  );

  const handleClear = useCallback(() => {
    onChange('');
    setSearchText('');
  }, [onChange, setSearchText]);

  return (
    <div onKeyDown={handleWrapperKeyDown}>
      <Input
        onClick={() => setOptionsVisibility(true)}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={className}
        onKeyDown={handleInputKeyDown}
        placeholder={t('searchPlaceholder')}
      />
      {value ? <ClearButton onClick={handleClear} /> : null}
    </div>
  );
};
